


















import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class BrowserSupport extends Vue {
    private features: any[] = [
        {
            name: 'Web Bluetooth',
            description: 'Bluetooth is needed to wirelessly connect to the sensors.',
            status: this.bleStatus,
        },
        {
            name: 'IndexedDB database',
            description: 'Data samples are stored in the browser using IndexedDB',
            status: this.databaseStatus,
        },
    ];

    public constructor() {
        super();
    }

    private bleStatus() {
        return !!navigator.bluetooth;
    }

    private databaseStatus() {
        return !!window.indexedDB;
    }
}
